<template>
  <div>
    <label class="label is-small">Branch (Code & Name)</label>
    <div class="control">
      <b-autocomplete v-model="branchName" size="is-small" :data="branches" placeholder="Search branches" @select="option => selectedBranch = option" @input="searchBranches" :loading="isFetchingBranches" v-validate="'required'">
        <template slot="empty">
          <span v-if="isFetchingBranches">
            Please wait...
          </span>
          <span v-if="branches.length === 0">
            No results found
          </span>
        </template>
      </b-autocomplete>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash/debounce'

export default {
  data: () => ({
    branchName: '',
    branches: [],
    selectedBranch: 0,
    isFetchingBranches: false
  }),
  methods: {
    searchBranches: debounce(function() {
      this.isFetchingBranches = true
      axios
        .get(`api/branches/search-by-name/${this.branchName}`)
        .then(response => {
          this.branches = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingBranches = false
        })
    }, 500),
    onClickSelectBranch(branchInfo) {
      this.$emit('triggerselectbranch', {
        branchId: branchInfo.branchId,
        branchName: branchInfo.branchName
      })
    }
  },
  watch: {
    selectedBranch() {
      if (this.selectedBranch) {
        this.onClickSelectBranch({
          branchId: this.selectedBranch.id,
          branchName: this.selectedBranch.value
        })
      } else {
        this.onClickSelectBranch({
          branchId: null,
          branchName: null
        })
      }
    }
  }
}
</script>